<p-dialog [header]="header" [(visible)]="visible" [modal]="true" appendTo="body"
  [style]="{'width': '1000px', 'height': '608px'}" [resizable]="false" (onHide)="hide()">

  <p>
    Total Devices: {{totalDeviceCount}}
  </p>

  <uv-table #table class="preview-devices-table" [columns]="cols" [value]="entries" dataKey="dataKey"
    [resizableColumns]="true" [scrollable]="true" scrollHeight="calc(425px)"
    [customSort]="true" (sortFunction)="doCustomSort($event)" (onFilter)="onFilterChange()"
    [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">

    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th uvResizableColumn [uvSortableColumn]="col.field"
            style="flex-basis: 10px; flex-grow: 1;">
            {{col.header}}
            <uv-sortIcon [field]="col.field"></uv-sortIcon>
          </th>
        }
      </tr>
      <tr>
        @for (col of columns; track col) {
          <th style="flex-basis: 10px; flex-grow: 1;">
            <input #filter pInputText type="text" style="width: 100%;"
              (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [style]="TableRowStyle" [uvSelectableRow]="rowData">
          @for (col of columns; track col) {
            <td style="flex-basis: 10px; flex-grow: 1;">
              <span class="uv-table-value">{{rowData[col.field]}}</span>
            </td>
          }
        </tr>
      </ng-template>

    </uv-table>

    <p-footer>
      <button type="button" pButton icon="fa fa-times" (click)="hide()" label="Close"></button>
    </p-footer>

  </p-dialog>